const TOKEN_KEY = 'bp_borrower_access_token';
const LOAN_NUMBER_KEY = 'bp_borrower_loan_number';

export function getBorrowerToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setBorrowerToken(token) {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export function getBorrowerLoanNumber() {
  try {
    return sessionStorage.getItem(LOAN_NUMBER_KEY);
  } catch {
    return null;
  }
}

export function setBorrowerLoanNumber(loanNumber) {
  try {
    if (loanNumber) sessionStorage.setItem(LOAN_NUMBER_KEY, String(loanNumber));
    else sessionStorage.removeItem(LOAN_NUMBER_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export function clearBorrowerSession() {
  setBorrowerToken(null);
  setBorrowerLoanNumber(null);
}

export function storeBorrowerSession({ accessToken, loanNumber }) {
  setBorrowerToken(accessToken);
  if (loanNumber != null) setBorrowerLoanNumber(loanNumber);
}
